
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './receiptHeaders';
import { Receipt } from '@/interfaces/models/Receipt';

@Component
export default class ReceiptTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Receipt[];
  @Prop({ type: Boolean, default: true }) public pagination!: boolean;
  @Prop({ type: Number, required: true }) public total!: number;

  public expanded: string[] = [];

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }
}
